import 'bootstrap/dist/css/bootstrap.min.css';
import 'animate.css/animate.css';
import axios from "axios";
import './css/style.css';

import { createApp } from 'vue'
import App from './App.vue'


let variables = window.location.href.split('?');

if ( variables.length <= 1) {
    console.error("The landing page is not defined.");
    setTimeout(() => {
        window.location.href='https://ianic.eu'
    },3000);
} else {
    let queryString = new URLSearchParams(variables[1]);

    let deya=undefined;

    for (let pair of queryString.entries()) {
        if(pair[0] === "deya") {
            deya = pair[1];
            break;
        }
    }

    if(deya!==undefined){
        axios({
            url:'/deya.json',
            responseType: 'json'
        }).then((response) => {
            let filename_json='';

            Object.keys(response.data).forEach((key,i) => {
                if (key === deya){
                    filename_json=Object.values(response.data)[i];
                }
            });

            if(filename_json !== ''){
                axios({
                    url:'/messages/'+filename_json,
                    responseType: 'json',
                }).then((response) => {
                    const vue=createApp(App);
                    window.messages=response.data;
                    vue.mount('#app');
                }).catch(() => {
                    console.error("The messages are invalid.");
                    setTimeout(() => {
                        window.location.href='https://ianic.eu'
                    },3000);
                });
            } else {
                console.error("The messages are invalid.");
                setTimeout(() => {
                    window.location.href='https://ianic.eu'
                },3000);
            }

        }).catch(() => {
            console.error("Configuration is invalid");
            setTimeout(() => {
                window.location.href='https://ianic.eu'
            },3000);
        });
    } else{
        console.error("The landing page is not defined.");
        setTimeout(() => {
            window.location.href='https://ianic.eu'
        },3000);
    }
}